// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const seel: PokeData = {
  "id": 86,
  "name": "seel",
  "height": 11,
  "weight": 900,
  "base_experience": 65,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "headbutt",
    "take-down",
    "double-edge",
    "growl",
    "water-gun",
    "ice-beam",
    "aurora-beam",
    "waterfall",
    "rest",
    "icy-wind",
    "charm",
    "safeguard",
    "encore",
    "hail",
    "dive",
    "water-sport",
    "brine",
    "aqua-ring",
    "aqua-tail",
    "ice-shard",
    "aqua-jet",
    "snowscape"
  ],
  "moves": [
    "headbutt",
    "growl",
    "brine",
    "aqua-tail",
    "ice-shard",
    "aqua-jet",
    "rain-dance",
    "bubble",
    "aqua-cutter",
    "liquidation",
    "water-spout",
    "life-dew",
    "bubble-beam"
  ],
  "evolution_chain": {
    "id": 37,
    "item": null,
    "species": [
      {
        "name": "seel",
        "order": 94,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dewgong",
        "order": 95,
        "types": [
          PokeType.WATER,
          PokeType.ICE
        ],
        "evolves_from_species_id": 86,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 63.75,
    "speed": 45,
    "ability_power": 45
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
